//Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import styles from './LearnHub.module.css'
//Translation
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import { pt, es, enUS } from 'date-fns/locale';
//Components
import MngUsers from '../../components/MngUsers';
import MngEnrollments from '../../components/MngEnrollments';
import MngDashboards from '../../components/MngDashboards';
import MngConfig from '../../components/MngConfig';
//context
import { useAuthValue } from '../../context/AuthContext';
import { useLanguageValue } from '../../context/LanguageContext';
// Hooks
import { useEffect } from 'react';

const LearnHub = ({ userSetLanguage, userInfo, hideMenuItem }) => {

    const { t } = useTranslation(['learnhub']);
    const { preferenceLanguage } = useLanguageValue();
    let localeDate = pt;


    useEffect(() => {
        hideMenuItem("learnhub")
    }, [])

    const changeLanguage = (language) => {
        localStorage.setItem('preferenceLanguage', language);
        i18n.changeLanguage(language);
    };

    useEffect(() => {
        if (preferenceLanguage) {
            var language = "en";
            switch (preferenceLanguage) {
                case "Português":
                    language = "pt";
                    localeDate = pt;
                    break;
                case "Espanhol":
                    language = "es";
                    localeDate = es;
                    break;
                case "Inglês":
                    language = "en";
                    localeDate = enUS;
                    break;
                default:
                    language = "en";
                    localeDate = enUS;
            }
            changeLanguage(language);
            i18n.changeLanguage(language);
        }
    }, [preferenceLanguage])

    return (
        <div className={`${styles.body_project}`}>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className={`nav-link active ${styles.abaItems}`} id="users-tab" data-bs-toggle="tab" data-bs-target="#users" type="button" role="tab" aria-controls="users" aria-selected="true">
                        {t('learnhub:home.usuarios')}
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link ${styles.abaItems}`} id="enrollment-tab" data-bs-toggle="tab" data-bs-target="#enrollment" type="button" role="tab" aria-controls="enrollment" aria-selected="false">
                        {t('learnhub:home.cursos')}
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link ${styles.abaItems}`} id="config-tab" data-bs-toggle="tab" data-bs-target="#config" type="button" role="tab" aria-controls="config" aria-selected="false">
                    {t('learnhub:home.configurações')}
                    </button>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent">
                <div className={`tab-pane fade show active ${styles.backAba}`} id="users" role="tabpanel" aria-labelledby="users-tab">
                    <MngUsers userInfo={userInfo} />
                </div>
                {userInfo &&
                    <div className={`tab-pane fade ${styles.backAba}`} id="enrollment" role="tabpanel" aria-labelledby="enrollment-tab">
                        <MngEnrollments userInfo={userInfo} />
                    </div>}
                <div className={`tab-pane fade ${styles.backAba}`} id="config" role="tabpanel" aria-labelledby="config-tab">
                    <MngConfig userInfo={userInfo} />
                </div>
            </div>
        </div>
    )
}

export default LearnHub